export const THEME_PREFERENCES = ['system', 'light', 'dark'] as const

export type ThemePreference = typeof THEME_PREFERENCES[number]
export type ResolvedTheme = 'light' | 'dark'

const DARK_MEDIA_QUERY = '(prefers-color-scheme: dark)'

export function isThemePreference(value: string | null): value is ThemePreference {
  return value === 'system' || value === 'light' || value === 'dark'
}

export function resolveThemePreference(
  preference: ThemePreference,
  systemDark: boolean,
): ResolvedTheme {
  return preference === 'system'
    ? systemDark ? 'dark' : 'light'
    : preference
}

export function generateInitialThemeScript(storageKey: string) {
  return `;(() => {
  try {
    const stored = localStorage.getItem(${JSON.stringify(storageKey)})
    const preference = stored === 'system' || stored === 'light' || stored === 'dark'
      ? stored
      : 'system'
    const systemDark = typeof matchMedia === 'function'
      && matchMedia('${DARK_MEDIA_QUERY}').matches
    const resolved = preference === 'system'
      ? systemDark ? 'dark' : 'light'
      : preference
    const root = document.documentElement
    root.classList.toggle('dark', resolved === 'dark')
    root.dataset.themePreference = preference
    root.style.colorScheme = resolved
  } catch {
    const systemDark = typeof matchMedia === 'function'
      && matchMedia('${DARK_MEDIA_QUERY}').matches
    const resolved = systemDark ? 'dark' : 'light'
    const root = document.documentElement
    root.classList.toggle('dark', systemDark)
    root.dataset.themePreference = 'system'
    root.style.colorScheme = resolved
  }
})()`
}
